export default __webpack_public_path__ + "static/media/contactback.682fbde3.jpg";